export const orderProjectsForWorkNav = (projects = [], pinnedProjectIds = []) => {
  const pinned = new Set(pinnedProjectIds.map(String));
  const sorted = [...projects].sort((left, right) => new Date(right.updatedAt || 0) - new Date(left.updatedAt || 0));
  return [
    ...sorted.filter((project) => pinned.has(String(project._id))),
    ...sorted.filter((project) => !pinned.has(String(project._id))),
  ];
};